<template>
  <v-dialog v-model="isDialogVisible" max-width="650">
    <v-card class="prompts-dialog">
      <v-btn class="button-close ma-4" icon @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title>
        <h4 class="mt-1">{{ selectedPromptUserId ? 'Редактирование промпта' : 'Добавить промпт в Мои запросы' }}</h4>
      </v-card-title>
      <v-card-text>
        <div class="mt-5">
          <v-text-field v-model="form.title"  outlined dense class="_mr-3"></v-text-field>
        </div>
        <div class="">
          <v-textarea v-model="form.content" counter maxlength="1000" outlined dense class="_mr-3"></v-textarea>
        </div>
        <div class="d-flex justify-end mt-2 mb-3" >
          <v-btn @click="close()" color="primary" outlined class="mr-3">Отменить</v-btn>
          <v-btn @click="save()" color="primary" :disabled="!form.content || !form.title" :loading="loading.savePromptUser">
            {{ selectedPromptUserId ? 'Сохранить' : 'Добавить' }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
    <MsgDialog v-model="showOkAddDialog" @ok="onOk()"
      title="Промпт успешно добавлен в Мои запросы"
      text="Чтобы использовать сохранённый запрос, откройте раздел с Готовыми запросами в разделе AI-эксперта или в карточке кандидата"
      _textOk="Перейти в AI-эксперта"
    />
    <MsgDialog v-model="showOkEditDialog" @ok="onOk()"
      title="Промпт успешно отредактирован"
    />
  </v-dialog>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { cloneDeep } from 'lodash';
import MsgDialog from "@/components/ui/MsgDialog"

export default {
  name: 'PromptEditDialog',
  components: {
    MsgDialog
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: Boolean,
  },
  data: () => ({
    form: {
      title: '',
      content: '',
    },
    showOkAddDialog: false,
    showOkEditDialog: false,
  }),
  watch: {
    async value(val) {
      if (val) {
        if (this.getSelectedPromptUser) {
          const prompt = await this.loadPromptUser(this.selectedPromptUserId)
          this.form.content = prompt.content
          this.form.title = prompt.title
        } else {
          this.setSelectedPromptUserId(0)
          this.form.content = ''
          this.form.title = ''
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      promptsUser: 'ai/prompts/promptsUser',
      loading: 'ai/prompts/loading',
      selectedPromptUserId: 'ai/prompts/selectedPromptUserId',
      getSelectedPromptUser: 'ai/prompts/getSelectedPromptUser',
    }),
    isDialogVisible: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.close()
        }
      },
    },
  },
  methods: {
    ...mapActions({
      editPromptUser: 'ai/prompts/editPromptUser',
      loadPromptUser: 'ai/prompts/loadPromptUser',
    }),
    ...mapMutations({
      setSelectedPromptUserId: 'ai/prompts/setSelectedPromptUserId',
    }),
    close(ret) {
      this.$emit('input', ret);
    },
    async save(ret) {
      const response = await this.editPromptUser(this.form)
      if (response) {
        if (this.selectedPromptUserId)
          this.showOkEditDialog = true
        else
          this.showOkAddDialog = true
      }
    },
    onOk() {
      this.showOkAddDialog = false
      this.showOkEditDialog = false
      this.close()
    }
  }
}
</script>

<style>

</style>
